<template>
    <el-button :icon="icon" :disabled="disabled" :class="className" :type="type" :size="size" :loading="loading" @click="clickHandle" :style="'width:' + width">
      <slot/>
      {{label}}
    </el-button>
</template>

<script>

    export default {
        props:["label","type","className","size","disabled","width","icon"],
        name:"loading-button",
        data() {
            return {
                loading:false
            };
        },
        computed: {},
        methods: {
            clickHandle(){
                this.loading = true;
                this.$emit("clickHandle",this);
            },
            closeLoad(){
                this.loading = false;
            }
        },
        created() {},
        mounted() {},
        watch: {}
    }
</script>
<style scoped>
</style>
